/**
 * Clipboard utilities for copying results and sharing data
 */

export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      // Modern clipboard API
      await navigator.clipboard.writeText(text);
      return true;
    } else {
      // Fallback for older browsers or non-HTTPS contexts
      return copyToClipboardFallback(text);
    }
  } catch (error) {
    console.error('Failed to copy to clipboard:', error);
    return copyToClipboardFallback(text);
  }
}

function copyToClipboardFallback(text: string): boolean {
  try {
    // Create temporary textarea element
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.left = '-999999px';
    textarea.style.top = '-999999px';
    document.body.appendChild(textarea);
    
    // Select and copy
    textarea.focus();
    textarea.select();
    const successful = document.execCommand('copy');
    
    // Clean up
    document.body.removeChild(textarea);
    return successful;
  } catch (error) {
    console.error('Fallback clipboard copy failed:', error);
    return false;
  }
}

export function formatQuickShareText(grossIncome: number, netIncome: number, frequency: 'monthly' | 'yearly'): string {
  const formatCurrency = (amount: number) => 
    new Intl.NumberFormat('en-ZA', { style: 'currency', currency: 'ZAR' }).format(amount);

  const monthlyGross = grossIncome / 12;
  const monthlyNet = netIncome / 12;

  if (frequency === 'monthly') {
    return `🇿🇦 SA Tax Calculator Result:
Required Gross: ${formatCurrency(monthlyGross)}/month (${formatCurrency(grossIncome)}/year)
Desired Net: ${formatCurrency(monthlyNet)}/month (${formatCurrency(netIncome)}/year)

Calculate yours: ${window.location.origin}`;
  } else {
    return `🇿🇦 SA Tax Calculator Result:
Required Gross: ${formatCurrency(grossIncome)}/year (${formatCurrency(monthlyGross)}/month)
Desired Net: ${formatCurrency(netIncome)}/year (${formatCurrency(monthlyNet)}/month)

Calculate yours: ${window.location.origin}`;
  }
}